import { array, boolean, lazy, mixed, number, object, string } from "yup";

import { type FunctionBody, NativeFunctionBodyId, Type } from "~/models/dto";
import { toValues } from "~/tools/to-values";

export interface FormMode {
	formType: FormType;
	title: string;
	actionText: string;
}

export type FormType = "Update" | "Create";

export const parametersValidation = array(
	object()
		.shape({
			id: number().label("id").optional(),
			lastUpdateTimestamp: number().optional(),
			name: string().label("name"),
			type: string().label("type"),
			required: boolean().label("required"),
			multiple: boolean().label("multiple"),
			_type: mixed()
				.default(Type.Parameter)
				.transform((type) => type as any),
		})
		.required(),
);

export const functionBodyValidation = lazy((fn?: FunctionBody) =>
	fn?._type === Type.NativeFunctionBody
		? object()
				.shape({
					nativeFunctionBodyId: string().oneOf(toValues(NativeFunctionBodyId)).required(),
					_type: string().oneOf([Type.NativeFunctionBody]).default(Type.ScriptFunctionBody),
				})
				.required()
		: object()
				.shape({
					scriptBody: string().label("Script").required(),
					_type: string().oneOf([Type.ScriptFunctionBody]).default(Type.ScriptFunctionBody),
				})
				.required(),
);

export const identifierValidation = mixed()
	.label("Identifier")
	.notRequired()
	.transform((value: string | null | undefined) => (value ? value.trim() : undefined));

export const handlebarsTemplateValidation = string()
	.label("template")
	.trim()
	.required()
	.transform((value: string | null | undefined) => (value ? value.trim() : undefined));

export const nameValidation = string().label("Name").trim().required();
export const descriptionValidation = string().label("Description").trim().optional();
export const optionalNumberValidation = number()
	.optional()
	.transform((str: string | number) => str || 0);
